<template>
	<div class="page-header">
		<div class="form-row header-style">

			<div class="form-group col-md-3" style="margin:0px">
				<div class="form-row">
					<h3 class="form-group header-title" style="margin:0px">Mapping Data </h3>
				</div>
			</div>


			<div class = "col-md-2"></div>
			<div class = "col-md-2"></div>
			<div class = "col-md-3"></div>
		</div>
	</div>
</template>

<script>


export default {
	name: "MappingHeader",
	components:{},
	data(){
		return{

		}
	},
	methods:{

	}
}
</script>
